// extracted by mini-css-extract-plugin
export default {"selector":"VideofeedFiltersModal_selector__HwgHN"};